import { Helmet } from "react-helmet";
import Canonical from "../../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import { useSitemap } from "../../../../shared/hooks/use-sitemap";
import CorporateBanner from "../../../../components/common/form/CorporateBanner";
import { LinkArr } from "../../../../components/common/svg/AllSvg";
import { useEffect, useState } from "react";
import ProjectRouteDetails from "./ProjectRouteDetails";
import { url } from "../../../../shared/utils/url";

const ProjectRoute = () => {
    const { t } = useTranslation('common');
    const [detailOpen, setDetailOpen] = useState<boolean>(false);
    useSitemap();

    useEffect(() => {
        if (detailOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [detailOpen]);

    return (
        <>
            {detailOpen && <ProjectRouteDetails detailOpen={detailOpen} setDetailOpen={setDetailOpen} />}
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.project_route.title")}</title>
                <meta name="description" content={t("seo_friendly.project_route.desc")} />
            </Helmet>

            <div className='bg-white dark:bg-bgDarkDull'>
                <CorporateBanner title={t("corporate.content_pages.project_route.title")} root1={t("corporate.content_pages.photo_gallery.home")} root2={t("corporate.content_pages.illustrative_designs.subtitle")} root3={t("corporate.content_pages.project_route.title")} />

                <div className="corporate-pages project-route" id="home">
                    <div className="project-route-aOIIA"><img alt="pattern" src={`${url?.bucketUrl}/media/images/Mask_group_NxSaDVN.original.png`} className="dark:opacity-[0.1]" /></div>

                    <div className="container project-route-aOIIB relative z-[1]">
                        <div className="project-route-aOIIC">
                            <h1 className="text-blackDull dark:text-textBlackDull font-bold max-w-[460px]">{t("corporate.content_pages.project_route.line1")}</h1>

                            <div className="project-route-aOIID">
                                <h5 className="text-justify">{t("corporate.content_pages.project_route.line2")}</h5>

                                <h5 className="text-justify">{t("corporate.content_pages.project_route.line3")}</h5>

                                <h5 className="text-justify">{t("corporate.content_pages.project_route.line4")}</h5>
                            </div>

                            <button className="flex border border-primaryText h-[35px] justify-center rounded-[10px] shadow-[0px_6px_12px_-6px_rgba(24,39,75,0.12),0px_8px_24px_-4px_rgba(24,39,75,0.08)] text-primaryText text-sm w-fit dark:border-white dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] dark:text-white focus:shadow-[0_0_0_2px_#1a1f365e] font-extrabold gap-[10px] hover:shadow-[0_0_0_2px_#1a1f365e] items-center mt-[12px] px-[14px] uppercase xlx:h-[40px] xlx:px-[19px]" onClick={() => setDetailOpen(true)}>
                                {t("corporate.banner.view_details")}
                                <div className="pb-[2.5px]">
                                    <LinkArr className="h-[10px] w-[9px] dark:fill-white fill-primaryText min-w-[9px] xlx:h-[11px] xlx:min-w-[10px] xlx:w-[10px]" />
                                </div>
                            </button>
                        </div>

                        <div className="project-route-aOIIE">
                            <div className="relative">
                                <div className="project-route-aOIIF">
                                    <div className="project-route-aOIIC">
                                        <div className="project-route-aOIIG">
                                            <div className="flex bg-white h-[16px] justify-center rounded-full w-[16px] items-center min-w-[16px] xlx:h-[20px] xlx:min-w-[20px] xlx:w-[20px] xs:h-[18px] xs:min-w-[18px] xs:w-[18px]">
                                                <div className="project-route-aOIIh"></div>
                                            </div>
                                            <h5>Functional</h5>
                                        </div>

                                        <div className="project-route-aOIIG">
                                            <div className="flex bg-white h-[16px] justify-center rounded-full w-[16px] items-center min-w-[16px] xlx:h-[20px] xlx:min-w-[20px] xlx:w-[20px] xs:h-[18px] xs:min-w-[18px] xs:w-[18px]">
                                                <div className="project-route-aOIIl"></div>
                                            </div>
                                            <h5>Opening Soon</h5>
                                        </div>

                                        <div className="project-route-aOIIG">
                                            <div className="flex bg-white h-[16px] justify-center rounded-full w-[16px] items-center min-w-[16px] xlx:h-[20px] xlx:min-w-[20px] xlx:w-[20px] xs:h-[18px] xs:min-w-[18px] xs:w-[18px]">
                                                <div className="project-route-aOIII"></div>
                                            </div>
                                            <h5>Under Progress</h5>
                                        </div>
                                    </div>
                                </div>
                                <img alt="project-route" src={`${url?.bucketUrl}/media/images/about-project_IJLPEqJ.original.png`} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProjectRoute;